(function () {
  if (window.ZehnProductCard) return;

  var TOUCH_ADD_TIMEOUT = 1800;
  var TOUCH_MOVE_THRESHOLD = 12;
  var CLOSE_DELAY = 800;
  var WIDTHS = [240, 360, 480, 720];

  var isTouch = 'ontouchstart' in window || (navigator.maxTouchPoints || 0) > 0;
  var state = new WeakMap();
  var fragmentCache = {};
  var preloaded = {};

  /* ---------- image helpers ----------------------------------------- */
  function withWidth(url, width) {
    if (!url) return url;
    if (/([?&])width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + width);
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function srcsetFor(url) {
    return WIDTHS.map(function (w) { return withWidth(url, w) + ' ' + w + 'w'; }).join(', ');
  }

  /* Warm the browser cache using the same srcset/sizes the <img> uses, so
     the candidate that gets picked on swap is already downloaded. */
  function preload(url, sizes) {
    if (!url || preloaded[url]) return;
    preloaded[url] = true;
    var pre = new Image();
    if (sizes) pre.sizes = sizes;
    pre.srcset = srcsetFor(url);
    pre.src = withWidth(url, 560);
  }

  function cardState(card) {
    var existing = state.get(card);
    if (existing) return existing;

    var media = {all: [], colors: {}};
    try {
      media = JSON.parse(card.dataset.pcImages || '{"all":[],"colors":{}}');
    } catch (error) { /* keep the empty default */ }

    var colorData = card.querySelector('[data-pc-color-data]');
    var choices = [];
    if (colorData) {
      try { choices = JSON.parse(colorData.dataset.pcColorData || '[]'); } catch (error) { choices = []; }
    }
    var next = {
      model: card.dataset.pcModel === 'true',
      choices: choices,
      media: {all: media.all || [], colors: media.colors || {}},
      img: card.querySelector('[data-pc-img]'),
      /* colour matched by an active filter, so hover/arrows stay in that colour */
      color: card.dataset.pcColor || null,
      index: 0
    };
    if (next.model) {
      var selectedIndex = choices.findIndex(function (choice) { return choice.n === next.color; });
      next.index = selectedIndex < 0 ? 0 : selectedIndex;
    }
    state.set(card, next);
    return next;
  }

  function activeSet(s) {
    if (s.model) return s.choices;
    var set = s.color ? s.media.colors[s.color] : null;
    return set && set.length ? set : s.media.all;
  }

  function warmSet(card) {
    var s = cardState(card);
    var key = s.color || '*';
    if (s.warmed === key) return;
    s.warmed = key;

    var set = activeSet(s);
    var sizes = s.img ? s.img.getAttribute('sizes') : null;
    /* Detached preload images have no layout for sizes=auto. Use the
       rendered card width so colour/arrow warming selects the same file. */
    if (sizes && /^auto(?:,|$)/.test(sizes) && s.img) {
      var renderedWidth = s.img.getBoundingClientRect().width;
      sizes = renderedWidth > 0 ? renderedWidth + 'px' : sizes.replace(/^auto,?\s*/, '');
    }
    if (s.model) {
      var nextChoice = set[(s.index + 1) % set.length];
      if (nextChoice) preload(nextChoice.u, sizes);
    } else {
      for (var i = 0; i < set.length; i++) preload(set[i].u, sizes);
    }
  }

  function paint(card) {
    var s = cardState(card);
    var set = activeSet(s);
    card.dataset.pcMulti = set.length > 1 ? 'true' : 'false';
    if (!s.img || !set.length) return;

    if (s.index >= set.length) s.index = 0;
    var next = set[s.index];
    if (!next || !next.u) return;

    s.img.srcset = srcsetFor(next.u);
    s.img.src = withWidth(next.u, 560);
    s.img.alt = next.a || '';
    if (s.model) {
      s.color = next.n;
      card.dataset.pcColor = next.n;
      card.dataset.pcVariant = next.v;
      card.querySelectorAll('[data-pc-product-link]').forEach(function (link) { link.href = next.url; });
      card.querySelectorAll('[data-pc-swatch]').forEach(function (swatch) {
        swatch.setAttribute('aria-pressed', swatch.dataset.pcSwatch === next.n ? 'true' : 'false');
      });
      var activeSwatch = card.querySelector('[data-pc-swatch][aria-pressed="true"]');
      var swatchRow = card.querySelector('.pc-swatches');
      if (activeSwatch && swatchRow) {
        var activeRect = activeSwatch.getBoundingClientRect();
        var rowRect = swatchRow.getBoundingClientRect();
        if (activeRect.right > rowRect.right) swatchRow.scrollLeft += activeRect.right - rowRect.right;
        if (activeRect.left < rowRect.left) swatchRow.scrollLeft -= rowRect.left - activeRect.left;
      }
      var price = card.querySelector('.pc-price');
      var compare = card.querySelector('.pc-compare');
      if (price) {
        price.textContent = next.p;
        price.classList.toggle('pc-price--sale', !!next.c);
      }
      if (compare) {
        compare.textContent = next.c || '';
        compare.hidden = !next.c;
      }
      var stock = card.querySelector('[data-pc-stock]');
      if (stock) stock.hidden = next.available;
      var wish = card.querySelector('.wishlist-hero-custom-button');
      if (wish) {
        wish.setAttribute('data-wlh-variantId', next.v);
        wish.setAttribute('data-wlh-price', next.amount);
        wish.setAttribute('data-wlh-image', withWidth(next.u, 1024));
        wish.setAttribute('data-wlh-link', new URL(next.url, window.location.origin).href);
      }
      var status = card.querySelector('[data-pc-color-status]');
      if (status) status.textContent = next.n;
    }
  }

  /* ---------- Wishlist Hero ----------------------------------------- */
  /* Wishlist Hero sits inside the card's <a>. Block the link navigation
     in the capture phase, but don't stop propagation, so the click
     still reaches Wishlist Hero's own handler. */
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('[data-pc-wish]')) {
      event.preventDefault();
    }
  }, true);

  /* ---------- delegated card interaction ---------------------------- */
  document.addEventListener('pointerover', function (event) {
    var card = event.target.closest && event.target.closest('[data-pc]');
    if (card) warmSet(card); /* preload before the first click, not after */
  }, {passive: true});

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest) return;
    var clickedCard = target.closest('[data-pc-model]');
    if (clickedCard && cardState(clickedCard).ignoreClickUntil > Date.now()) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    var nav = target.closest('[data-pc-nav]');
    if (nav) {
      event.preventDefault();
      event.stopPropagation();
      var navCard = nav.closest('[data-pc]');
      var navState = cardState(navCard);
      var navSet = activeSet(navState);
      if (navSet.length <= 1) return;

      navState.index = nav.dataset.pcNav === 'prev'
        ? (navState.index === 0 ? navSet.length - 1 : navState.index - 1)
        : (navState.index + 1) % navSet.length;

      paint(navCard);
      return;
    }

    var swatch = target.closest('[data-pc-swatch]');
    if (swatch) {
      event.preventDefault();
      event.stopPropagation();
      var swCard = swatch.closest('[data-pc]');
      var swState = cardState(swCard);
      var name = swatch.dataset.pcSwatch;
      if (swState.model) {
        var colorIndex = swState.choices.findIndex(function (choice) { return choice.n === name; });
        if (colorIndex < 0) return;
        swState.index = colorIndex;
        paint(swCard);
        warmSet(swCard);
        return;
      }
      if (!isTouch) return;

      swState.color = swState.color === name ? null : name;
      swState.index = 0;
      paint(swCard);
      warmSet(swCard);
      return;
    }

    var add = target.closest('[data-pc-add]');
    if (add) {
      event.preventDefault();
      event.stopPropagation();
      openSheet(add.closest('[data-pc]'));
    }
  });

  /* swatch hover switching (pointerover bubbles, mouseenter does not) */
  document.addEventListener('pointerover', function (event) {
    if (isTouch) return;
    var swatch = event.target.closest && event.target.closest('[data-pc-swatch]');
    if (!swatch) return;

    var card = swatch.closest('[data-pc]');
    var s = cardState(card);
    if (s.model || s.color === swatch.dataset.pcSwatch) return;

    s.color = swatch.dataset.pcSwatch;
    s.index = 0;
    paint(card);
    warmSet(card);
  }, {passive: true});

  var swipe = null;
  document.addEventListener('pointerdown', function (event) {
    var media = event.target.closest && event.target.closest('[data-pc-model] .pc-media');
    if (!media || (event.button !== undefined && event.button !== 0) || event.target.closest('button, [data-pc-wish]')) return;
    swipe = {card: media.closest('[data-pc]'), id: event.pointerId, x: event.clientX, y: event.clientY};
  }, {passive: true});

  document.addEventListener('pointerup', function (event) {
    if (!swipe || swipe.id !== event.pointerId) return;
    var start = swipe;
    swipe = null;
    var dx = event.clientX - start.x;
    var dy = event.clientY - start.y;
    if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.3 || !start.card.isConnected) return;
    var s = cardState(start.card);
    if (s.choices.length < 2) return;
    s.index = (s.index + (dx < 0 ? 1 : -1) + s.choices.length) % s.choices.length;
    s.ignoreClickUntil = Date.now() + 500;
    paint(start.card);
    warmSet(start.card);
  }, {passive: true});

  document.addEventListener('pointercancel', function () { swipe = null; }, {passive: true});
  document.addEventListener('dragstart', function (event) {
    if (event.target.closest && event.target.closest('[data-pc-model] .pc-media')) event.preventDefault();
  });
  document.addEventListener('keydown', function (event) {
    var card = event.target.closest && event.target.closest('[data-pc-model]');
    if (!card || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
    var s = cardState(card);
    if (s.choices.length < 2) return;
    event.preventDefault();
    s.index = (s.index + (event.key === 'ArrowRight' ? 1 : -1) + s.choices.length) % s.choices.length;
    paint(card);
    if (event.target.closest('[data-pc-swatch]')) {
      var selectedSwatch = card.querySelector('[data-pc-swatch][aria-pressed="true"]');
      if (selectedSwatch) selectedSwatch.focus({preventScroll: true});
    }
    warmSet(card);
  });

  /* touch reveal for the quick-add button */
  var touchY = null;
  var touchTimers = new WeakMap();

  document.addEventListener('touchstart', function (event) {
    var card = event.target.closest && event.target.closest('[data-pc]');
    if (!card) return;
    touchY = event.touches[0] ? event.touches[0].clientY : null;
  }, {passive: true});

  document.addEventListener('touchmove', function (event) {
    var card = event.target.closest && event.target.closest('[data-pc]');
    if (!card || touchY === null) return;
    var y = event.touches[0] ? event.touches[0].clientY : undefined;
    if (y === undefined) return;
    if (Math.abs(y - touchY) > TOUCH_MOVE_THRESHOLD) card.dataset.pcTouchAdd = 'true';
  }, {passive: true});

  function endTouch(event) {
    var card = event.target.closest && event.target.closest('[data-pc]');
    touchY = null;
    if (!card) return;

    var timer = touchTimers.get(card);
    if (timer) window.clearTimeout(timer);
    touchTimers.set(card, window.setTimeout(function () {
      card.dataset.pcTouchAdd = 'false';
      touchTimers.delete(card);
    }, TOUCH_ADD_TIMEOUT));
  }

  document.addEventListener('touchend', endTouch, {passive: true});
  document.addEventListener('touchcancel', endTouch, {passive: true});

  /* ================= quick add sheet =============================== */
  var sheet = document.querySelector('[data-qa]');
  var body = sheet && sheet.querySelector('[data-qa-body]');
  var titleEl = sheet && sheet.querySelector('[data-qa-title]');
  var priceEl = sheet && sheet.querySelector('[data-qa-price]');
  var compareEl = sheet && sheet.querySelector('[data-qa-compare]');
  var imageEl = sheet && sheet.querySelector('[data-qa-image]');
  var cardEl = sheet && sheet.querySelector('[data-qa-card]');

  var openHandle = null;
  var openVariantId = null;
  var openColor = null; /* {name, value} from a colour-filtered card */
  var scrollLock = '';
  var closeTimer = null;
  var current = null; /* {variants, names, selections} */

  var SPINNER = '<svg class="qa-spinner" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  function openSheet(card) {
    if (!sheet || !card) return;

    var handle = card.dataset.pcHandle;
    var title = card.querySelector('.pc-title');
    var price = card.querySelector('.pc-price');
    var compare = card.querySelector('.pc-compare');
    var img = card.querySelector('[data-pc-img]');

    titleEl.textContent = title ? title.textContent.trim() : '';
    priceEl.textContent = price ? price.textContent.trim() : '';
    priceEl.dataset.qaSale = price && price.classList.contains('pc-price--sale') ? 'true' : 'false';
    compareEl.textContent = compare ? compare.textContent.trim() : '';
    cardEl.setAttribute('aria-label', titleEl.textContent + ' – Schnellansicht');

    if (img) {
      imageEl.src = withWidth(img.currentSrc || img.src, 160);
      imageEl.alt = img.alt || '';
    }

    body.innerHTML = '<div class="qa-loading">' + SPINNER + 'Produktoptionen werden geladen…</div>';

    sheet.hidden = false;
    scrollLock = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { sheet.dataset.qaOpen = 'true'; });
    });

    openHandle = handle;
    openVariantId = card.dataset.pcVariant || null;
    openColor = card.dataset.pcColor
      ? {name: card.dataset.pcColorOption, value: card.dataset.pcColor}
      : null;
    loadFragment(handle);
  }

  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.dataset.qaOpen = 'false';
    document.body.style.overflow = scrollLock;
    openHandle = null;
    openVariantId = null;
    current = null;

    window.setTimeout(function () {
      if (sheet.dataset.qaOpen !== 'true') sheet.hidden = true;
    }, 300);
  }

  function loadFragment(handle) {
    var cached = fragmentCache[handle];
    if (cached) { injectFragment(handle, cached); return; }

    fetch('/products/' + encodeURIComponent(handle) + '?view=quick-add', {
      headers: {'X-Requested-With': 'fetch'}
    })
      .then(function (response) {
        if (!response.ok) throw new Error('bad status');
        return response.text();
      })
      .then(function (html) {
        fragmentCache[handle] = html;
        injectFragment(handle, html);
      })
      .catch(function () {
        if (openHandle !== handle) return;
        body.innerHTML =
          '<p class="qa-error">Die Produktoptionen konnten nicht geladen werden. Bitte öffnen Sie die Produktseite.</p>';
      });
  }

  function injectFragment(handle, html) {
    if (openHandle !== handle) return;
    body.innerHTML = html;

    var fragment = body.querySelector('[data-qa-fragment]');
    if (!fragment) return;

    var variants = [];
    var names = [];
    try {
      variants = JSON.parse(fragment.dataset.qaVariants || '[]');
      names = JSON.parse(fragment.dataset.qaOptionNames || '[]');
    } catch (error) { /* leave empty */ }

    var defaultId = String(openVariantId || fragment.dataset.qaDefault || '');
    var defaultVariant =
      variants.filter(function (v) { return String(v.id) === defaultId; })[0] || variants[0];

    var selections = {};
    if (defaultVariant) {
      names.forEach(function (name, i) { selections[name] = defaultVariant.o[i]; });
    }
    /* Quick add from a colour-filtered card opens in that colour. */
    if (openColor && names.indexOf(openColor.name) !== -1) {
      selections[openColor.name] = openColor.value;
    }

    current = {variants: variants, names: names, selections: selections, handle: handle};
    paintSheet();
  }

  function matchVariant(selections) {
    if (!current) return null;
    return current.variants.filter(function (variant) {
      return current.names.every(function (name, i) { return selections[name] === variant.o[i]; });
    })[0] || null;
  }

  function valueAvailable(name, value) {
    var test = {};
    Object.keys(current.selections).forEach(function (key) { test[key] = current.selections[key]; });
    test[name] = value;

    return current.variants.some(function (variant) {
      return variant.a && current.names.every(function (n, i) { return test[n] === variant.o[i]; });
    });
  }

  function paintSheet() {
    if (!current) return;

    body.querySelectorAll('[data-qa-value]').forEach(function (button) {
      var name = button.dataset.qaOptionName;
      var value = button.dataset.qaValue;
      var selected = current.selections[name] === value;

      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.dataset.qaUnavailable = valueAvailable(name, value) ? 'false' : 'true';
    });

    body.querySelectorAll('[data-qa-option]').forEach(function (field) {
      var label = field.querySelector('[data-qa-legend-value]');
      var value = current.selections[field.dataset.qaOption];
      if (label) label.textContent = value ? '— ' + value : '';
    });

    var variant = matchVariant(current.selections);
    if (variant) {
      priceEl.textContent = variant.p;
      priceEl.dataset.qaSale = variant.c ? 'true' : 'false';
      compareEl.textContent = variant.c || '';
    }

    var submit = body.querySelector('[data-qa-submit]');
    if (!submit) return;

    submit.dataset.qaVariant = variant ? variant.id : '';
    if (!variant) {
      setSubmit(submit, 'disabled', 'In den Warenkorb');
    } else if (!variant.a) {
      setSubmit(submit, 'soldout', 'Ausverkauft');
    } else {
      setSubmit(submit, 'ready', 'In den Warenkorb');
    }
  }

  function setSubmit(submit, state, label, icon) {
    submit.dataset.qaState = state;
    var span = submit.querySelector('[data-qa-submit-label]');
    if (span) span.innerHTML = (icon || '') + label;
  }

  /*
    Same cart-refresh contract as the popup and the buy-buttons block:
    prefer window.ZehnCartDrawer.refresh() directly, fall back to the
    zehn:cart:refresh event, and still fire the generic cart:refresh/
    cart:update events for anything else on the page listening for those.
  */
  function refreshCart() {
    var d = window.ZehnCartDrawer;
    var done;
    if (d && typeof d.refresh === 'function') {
      done = Promise.resolve(d.refresh());
    } else {
      document.dispatchEvent(new CustomEvent('zehn:cart:refresh', {bubbles: true}));
      done = Promise.resolve();
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
    document.dispatchEvent(new CustomEvent('cart:update', {bubbles: true}));
    return done;
  }

  function openDrawer() {
    var d = window.ZehnCartDrawer;
    if (d && typeof d.open === 'function') d.open();
    else document.dispatchEvent(new CustomEvent('zehn:cart:open', {bubbles: true}));
  }

  function addToCart(submit) {
    var id = submit.dataset.qaVariant;
    if (!id) return;

    setSubmit(submit, 'loading', 'Wird hinzugefügt…', SPINNER);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: [{id: Number(id), quantity: 1}]})
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(function (data) {
        setSubmit(submit, 'added', 'Hinzugefügt!', CHECK);

        /* fireMetaAddToCart(...) hook */
        document.dispatchEvent(new CustomEvent('zehn:add-to-cart', {
          detail: {handle: current && current.handle, variantId: id, cart: data}
        }));

        /* actually reaches the ZEHN cart drawer — the previous 'cart:refresh'-only
           dispatch here had no listener on cart-drawer.liquid, so the drawer
           never updated after a quick-add */
        refreshCart();

        if (closeTimer) window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () {
          closeTimer = null;
          closeSheet();
          openDrawer();
        }, CLOSE_DELAY);
      })
      .catch(function () {
        setSubmit(submit, 'ready', 'In den Warenkorb');
      });
  }

  if (sheet) {
    sheet.addEventListener('click', function (event) {
      if (event.target.closest('[data-qa-close]')) {
        closeSheet();
        return;
      }

      var value = event.target.closest('[data-qa-value]');
      if (value && current) {
        current.selections[value.dataset.qaOptionName] = value.dataset.qaValue;
        paintSheet();
        return;
      }

      var submit = event.target.closest('[data-qa-submit]');
      if (submit) addToCart(submit);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && sheet.dataset.qaOpen === 'true') closeSheet();
    });
  }

  window.ZehnProductCard = {open: openSheet, close: closeSheet};
})();

